import { render, staticRenderFns } from "./finishedFile.vue?vue&type=template&id=07987248"
import script from "./finishedFile.vue?vue&type=script&lang=js"
export * from "./finishedFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports